import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Stream } from 'src/models/stream';
import { ActivatedRoute } from '@angular/router';
import { InfiniteScrollableComponent } from '../base/infinite-scrollable/infinite-scrollable.component';
import { StreamService } from 'src/app/services/stream.service';
import { PlayerService } from 'src/app/services/player.service';
import { switchMap } from 'rxjs/operators';
import { AlertBoxType } from '../base/alert-box/alertboxtype';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent extends InfiniteScrollableComponent implements OnInit {

  public alertBoxTypes = AlertBoxType;

  public streams = new Array<Stream>();

  private itemsPerPage = 42;

  private searchText: string;

  public scrollControlEnabled = false;

  public loading = true;

  constructor(
    private route: ActivatedRoute,
    private streamService: StreamService,
    private playerService: PlayerService,
    private changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {

    // use switchmap to prevent race conditions
    this.route.params.pipe(
      switchMap(params => {
        
        this.scrollControlEnabled = false;
        this.loading = true;

        this.searchText = params['searchText'];

        this.streams = new Array<Stream>();
        this.start = 0;

        return this.streamService.getStationsByName(this.searchText, this.start, this.itemsPerPage);
      })
    ).subscribe((value: Stream[]) => {
      value.forEach((stream: Stream) => this.streams.push(stream));

      if (value.length === this.itemsPerPage) {
        this.scrollControlEnabled = true;
      }

      this.loading = false;

      this.changeDetector.detectChanges();
    });

  }

  protected getItemsPerPage(): number {
    return this.itemsPerPage;
  }

  protected loadStreams() {
    this.scrollControlEnabled = false;
    this.loading = true;

    this.streamService.getStationsByName(this.searchText, this.start, this.itemsPerPage).subscribe((value: Stream[]) => {
      value.forEach((stream: Stream) => this.streams.push(stream));

      if (value.length === this.itemsPerPage) {
        this.scrollControlEnabled = true;
      }

      this.loading = false;

      this.changeDetector.detectChanges();
    });
  }

  public onPlayStreamClicked(stream: Stream) {
    this.playerService.setCurrentStream(stream);
  }

}
